module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-franzi.38159c12.jpg";